import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import ContentCard from "./ContentCard";

/**
 * TableCard
 * A standardized card wrapper for tables with optional title and action area.
 */
export default function TableCard({ title, action, children, sx = {}, p = 2, ...props }) {
  return (
    <ContentCard
      p={p}
      sx={{ display: "flex", flexDirection: "column", gap: 1.5, ...sx }}
      {...props}
    >
      {(title || action) && (
        <Box
          sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}
        >
          {title ? (
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
          ) : (
            <span />
          )}
          {action}
        </Box>
      )}
      {children}
    </ContentCard>
  );
}

TableCard.propTypes = {
  title: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object,
  p: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
